import RecordTemplateId       from "../template/RecordTemplateId";
import RecordTemplateName     from "../template/RecordTemplateName";
import RecordTemplateRevision from "../template/RecordTemplateRevision";
import CustomerRecordWidgets  from "./widget/CustomerRecordWidgets";

class CustomerRecordTemplate {
  constructor(
    private readonly _id: RecordTemplateId = new RecordTemplateId(),
    private readonly _revision: RecordTemplateRevision = new RecordTemplateRevision(),
    private readonly _name: RecordTemplateName = new RecordTemplateName(),
    private readonly _widgets: CustomerRecordWidgets = new CustomerRecordWidgets(),
  ) {
  }

  get id() {
    return this._id;
  }

  get revision() {
    return this._revision;
  }

  get name() {
    return this._name;
  }

  get widgets() {
    return this._widgets;
  }
}

export default CustomerRecordTemplate;
